import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const ko: Translations = {
  common: {
    appName: appName,
    loading: '로딩 중...',
    save: '저장',
    cancel: '취소',
    confirm: '확인',
    delete: '삭제',
    edit: '수정',
    back: '뒤로',
    search: '검색',
    noResults: '결과가 없습니다',
    error: '오류가 발생했습니다',
    success: '성공',
  },
  header: {
    searchPlaceholder: '뉴스, 주제, 해시태그 검색...',
    searchPlaceholderMobile: '검색...',
    home: '홈',
    hotgirl: '핫걸',
    coser: '코스어',
    model: '모델',
    upload: '업로드',
    notifications: '알림',
    login: '로그인',
    register: '회원가입',
  },
  footer: {
    tagline: `코스어, 핫걸, 모델 사진 최고의 공유 플랫폼 ${appName}.`,
    copyright: `© {year} ${appName}. All rights reserved.`,
    sections: { explore: '탐색', account: '계정', support: '지원' },
    links: {
      home: '홈', hotgirl: '핫걸', coser: '코스어', model: '모델', aoDai: '아오자이',
      login: '로그인', register: '회원가입', upload: '사진 업로드', dashboard: '대시보드',
      terms: '이용약관', privacy: '개인정보처리방침', report: '신고', contact: '문의하기',
    },
  },
  collections: {
    title: '컬렉션',
    createAlbum: '앨범 만들기',
    saved: '저장됨',
    noSaved: '아직 저장된 사진이 없습니다',
    noSavedHint: '지금 사진 탐색하기 →',
    removedSave: '저장이 취소되었습니다',
    createModalTitle: '새 앨범 만들기',
    albumNamePlaceholder: '앨범 이름...',
    cancel: '취소',
    create: '만들기',
    albumCreated: '앨범이 생성되었습니다',
  },
  home: {
    title: '발견하기',
    titleHighlight: '아름다움',
    titleSuffix: '라이브',
    subtitle: '매일 업데이트되는 코스어, 핫걸, 모델 사진 수천 장',
    sortNewest: '최신순',
    sortTrending: '트렌딩',
    sortPopular: '인기순',
    allCategories: '전체',
    noMorePosts: '모든 사진을 보셨습니다',
  },
  auth: {
    login: {
      title: '로그인하여 계속',
      continueWithGoogle: 'Google로 계속',
      orLoginWithEmail: '또는 이메일로 로그인',
      email: '이메일',
      password: '비밀번호',
      forgotPassword: '비밀번호를 잊으셨나요?',
      submitButton: '로그인',
      loading: '로그인 중...',
      noAccount: '계정이 없으신가요?',
      registerLink: '지금 가입',
      errorCredentials: '이메일 또는 비밀번호가 올바르지 않습니다',
      successLogin: '로그인되었습니다!',
    },
    register: {
      title: '무료 계정 만들기',
      displayName: '표시 이름',
      displayNamePlaceholder: '홍길동',
      email: '이메일',
      password: '비밀번호',
      passwordPlaceholder: '최소 8자',
      confirmPassword: '비밀번호 확인',
      submitButton: '가입하기',
      loading: '계정 생성 중...',
      hasAccount: '이미 계정이 있으신가요?',
      loginLink: '로그인',
      errorPasswordMismatch: '비밀번호가 일치하지 않습니다',
      errorPasswordLength: '비밀번호는 최소 8자 이상이어야 합니다',
      errorGeneric: '회원가입 실패',
      successRegister: '회원가입이 완료되었습니다!',
      emailTaken: '이메일이 이미 사용 중입니다',
      serverError: '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    },
    forgotPassword: {
      title: '비밀번호 찾기',
      subtitle: '이메일을 입력하면 재설정 링크를 보내드립니다',
      email: '이메일',
      submitButton: '재설정 링크 보내기',
      backToLogin: '로그인으로 돌아가기',
      sending: '전송 중...',
      emailSent: '이메일이 전송되었습니다!',
      checkEmail: '{email}의 받은 편지함을 확인하여 비밀번호 재설정 링크를 받으세요.',
      instructions: '이메일을 입력하면 비밀번호 재설정 링크를 보내드립니다.',
    },
  },
  userMenu: {
    dashboard: '대시보드',
    collections: '컬렉션',
    settings: '설정',
    logout: '로그아웃',
  },
  settings: {
    title: '계정 설정',
    profile: {
      nav: '프로필',
      title: '프로필 정보',
      displayName: '표시 이름',
      username: '사용자 이름',
      website: '웹사이트',
      bio: '소개',
      bioPlaceholder: '자신을 소개해주세요...',
      changeAvatar: '아바타 변경',
      avatarHint: 'JPG, PNG, WebP 최대 5MB',
      saveButton: '변경사항 저장',
      saving: '저장 중...',
      savedSuccess: '변경사항이 저장되었습니다',
    },
    password: { 
      nav: '비밀번호',
      title: '비밀번호 변경',
      fields: {
        currentPassword: '현재 비밀번호',
        newPassword: '새 비밀번호',
        confirm: '새 비밀번호 확인',
      },
      errors: {
        confirm: '새 비밀번호가 일치하지 않습니다',
        minLength: '비밀번호는 최소 8자 이상이어야 합니다',
      },
      success: '비밀번호가 변경되었습니다',
      saving: '저장 중...',
      submit: '비밀번호 변경',
    },
    notifications: { 
      nav: '알림',
      title: '알림 설정',
      options: {
        likes: '내 사진을 좋아할 때',
        comments: '내 사진에 댓글을 달 때',
        replies: '내 댓글에 답글을 달 때',
        follows: '내가 팔로우할 때',
        approved: '내 게시물이 승인될 때',
        email_digest: '주간 이메일 요약',
        marketing: '프로모션 및 이벤트 알림',
      },
      saveSuccess: '알림 설정이 저장되었습니다',
      saving: '저장 중...',
      saveButton: '설정 저장',
    },
    security: { 
      nav: '보안',
      twoFactorAuth: '2단계 인증 (2FA)',
      twoFactorAuthHint: '앱의 인증 코드를 사용하여 보안을 강화하세요.',
      comingSoon: '곧 출시 예정',
      activeSessions: '활성 세션',
      currentBrowser: '현재 브라우저',
      lastLogin: '마지막 로그인',
      active: '활성',
      dangerZone: '위험 영역',
      deleteAccountHint: '계정을 삭제하면 모든 데이터가 영구적으로 삭제됩니다.',
      deleteAccount: '계정 삭제',
    },
  },
  post: {
    likes: '좋아요 {count}개',
    views: '조회수 {count}',
    shares: '공유 {count}회',
    comments: '댓글 {count}개',
    save: '저장',
    saved: '저장됨',
    share: '공유',
    linkCopied: '링크가 복사되었습니다!',
    follow: '팔로우',
    following: '팔로잉',
    relatedPosts: '관련 게시물',
    commentPlaceholder: '댓글 작성...',
    commentLoginPlaceholder: '로그인하여 댓글 작성...',
    commentSubmit: '게시',
    commentSubmitting: '게시 중...',
    noComments: '아직 댓글이 없습니다. 첫 번째 댓글을 남겨보세요!',
    savedToCollection: '컬렉션에 저장되었습니다',
    removedFromCollection: '저장이 취소되었습니다',
    description: '설명',
    profileView: '프로필 보기',
    replies: '답글',
    unsaved: '저장 취소됨',
    liked: '좋아요 누름',
    like: '좋아요',
  },
  notifications: {
    title: '알림',
    empty: '알림이 없습니다',
    markAllRead: '모두 읽음 표시',
    types: {
      like_post: '당신의 사진을 좋아했습니다',
      comment: '당신의 사진에 댓글을 달았습니다',
      reply: '당신의 댓글에 답글을 달았습니다',
      follow: '당신을 팔로우했습니다',
      approve: '당신의 게시물이 승인되었습니다',
      reject: '당신의 게시물이 거부되었습니다',
      system: '시스템 알림',
    },
  },
  search: {
    title: '검색 결과:',
    result: '결과',
    tryOtherKeywords: '다른 키워드로 시도해 보세요.',
    noResults: '검색 결과 없음:',
    placeholder: '검색...',
    thisHashtag: '이 해시태그가 포함된 사진',
    results: '개 결과',
  },
  upload: {
    title: '사진 업로드',
    dragDrop: '드래그 앤 드롭 또는 클릭하여 선택',
    supportedFormats: 'JPG, PNG, WebP, GIF 지원',
    submit: '게시',
    submitting: '게시 중...',
    titleField: '제목',
    cover: '커버',
    titlePlaceholder: '매력적인 제목을 입력하세요...',
    descriptionField: '설명',
    descriptionPlaceholder: '사진 세트에 대한 자세한 설명...',
    hashtagsField: '해시태그',
    statusField: '상태',
    statusPublic: '공개',
    statusPrivate: '비공개',
    statusDraft: '초안',
    error: '업로드 중 오류 발생',
    errorSelect: '최소 1장의 사진을 선택하세요',
    errorTitle: '제목을 입력하세요',
    photos: '사진',
    uploading: '업로드 중...',
  },
  notFound: {
    title: '페이지를 찾을 수 없습니다',
    subtitle: '찾으시는 페이지가 존재하지 않습니다.',
    backHome: '홈으로 돌아가기',
  },
  liked: {
    title: '좋아요 한 게시물',
    empty: '좋아요 한 게시물이 없습니다',
  },
  user: {
    unknown: '익명',
  },
  globalError: {
    title: '오류 발생',
    subtitle: '불편을 드려 죄송합니다. 다시 시도해 주세요.',
    retry: '다시 시도',
  },
  username: {
    posts: '게시물',
    likes: '좋아요',
    followers: '팔로워',
    following: '팔로잉',
    editProfile: '프로필 편집',
    message: '메시지',
    noPosts: '게시물이 없습니다',
    bio: '의 사진 보기',
    notFound: '사용자를 찾을 수 없습니다',
  },
  topic: {
    notFound: '주제를 찾을 수 없습니다',
    viewTitle: '주제의 사진 보기 ',
  },
  dashboard: {
    title: '대시보드',
    welcome: '환영합니다',
    stats: {
      posts: '게시물',
      views: '조회수',
      likes: '좋아요',
      comments: '댓글',
    },
  },
  adsblock: {
    title: "광고 차단기를 사용 중입니다",
    description: "고화질 이미지를 보려면 광고 차단기를 비활성화하고, 사이트를 무료로 유지할 수 있도록 도와주세요.",
    action: "비활성화했습니다 — 새로고침",
    cancel: "건너뛰기"
  },
  pwa: {
    title: `${appName}를 설치하여 더 나은 경험을 누리세요!`,
    iosSubtitle: `공유를 눌러 → 홈 화면에 추가`,
    androidSubtitle: `새로운 사진 세트가 출시되면 알림을 받습니다`,
    installButton: `설치 ${appName}`,
    disclaimer: `빠른 설치, 앱 스토어 필요 없음.`,
  },
  autotrans: {
    title: '자동 번역됨',
    translated: '번역',
    origin: '원본 콘텐츠',
  },
  subscription: {
    title: '알림 구독',
    description: '새로운 사진 세트가 출시되면 알림을 받습니다.',
    subscribeButton: '구독',
    unsubscribeButton: '구독 취소',
    subscribed: '알림을 구독했습니다.',
    unsubscribed: '알림 구독을 취소했습니다.',
    error: '구독 업데이트 중 오류가 발생했습니다. 다시 시도해 주세요.',
    success_tit: '🎉 알림이 활성화되었습니다!',
    denied_tit: '알림이 거부되었습니다',
    error_tit: '오류가 발생했습니다',
    success_des: '새로운 콘텐츠가 제공될 때 알림을 받게 됩니다.',
    denied_des: '브라우저 설정에서 다시 활성화할 수 있습니다.',
    error_des: '나중에 다시 시도해 주세요.',
    skip: '건너뛰기',
    processing: '처리 중...',
    noti: '알림 활성화',
    rule: '새로운 콘텐츠에 대한 알림만 표시합니다.',
    notify_title: `알림 - ${appName}`,
    notify_body: "새로운 갤러리가 출시되었습니다. 지금 확인해 보세요!",
  },
  contact: {
    title: '문의하기',
    subtitle: '여러분의 의견을 듣고 싶습니다! 아래 양식을 작성해 주시면 가능한 한 빨리 연락드리겠습니다.',
    name: '이름',
    email: '이메일',
    subject: '제목',
    message: '메시지',
    submitButton: '메시지 전송',
    sending: '전송 중...',
    successTitle: '메시지가 전송되었습니다!',
    successMessage: '연락해 주셔서 감사합니다. 곧 연락드리겠습니다.',
    errorTitle: '오류가 발생했습니다',
    errorMessage: '메시지 전송 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
    res_time_title: '응답 시간',
    res_time: '보통 1~3영업일 이내에 답변드립니다.',
    report_content: '콘텐츠 신고',
    report_content_hint: '게시물이나 사용자를 신고하려면 콘텐츠에서 직접 신고 버튼을 사용하거나 위의 “콘텐츠 신고”를 선택하세요.',
    value_default: '주제를 선택하세요',
    value_general: '일반 문의',
    value_report: '콘텐츠 신고',
    value_account: '계정 문제',
    value_business: '비즈니스 / 파트너십',
    value_feedback: '피드백 및 제안',
    value_other: '기타'
  },
  language: {
    label: `언어`,
    en: `English`, vi: `Tiếng Việt`, zh: `中文`, ja: `日本語`,
    ko: `한국어`, ar: `العربية`, fr: `Français`, es: `Español`,
    ru: `Русский`,
    hi: `हिन्दी`,
    id: `Indonesia`,
    de: `Deutsch`,
    pt: `Português`,
    it: `Italiano`,
  },
};

export default ko;
